<template>
    <v-container>
        <v-btn x-small text :to="order" id="thanksPage"></v-btn>
        <v-row v-if="tpl == 'cart'">
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold mb-6 text-center display-2">Shopping cart</p>
                <hr class="mb-5">
                <v-btn class="mb-5" tile outlined color="success" :to="'/'">
                    <v-icon left>mdi-arrow-left</v-icon>
                    <span v-if="lang == 'en'">Add more Products</span>
                    <span v-if="lang == 'es'">Agregar más productos</span>
                    <span v-if="lang == 'pt'">Adicionar mais produtos</span>
                </v-btn>
                <v-card raised>
                    <v-card-text>
                        <v-row style="font-weight: bold; color:white;" class="success d-none d-sm-flex">
                            <v-col
                                    cols="1"
                                    v-if="$vuetify.breakpoint.mdAndUp"
                            >
                            </v-col>
                            <v-col
                                    cols="5"
                                    class="text-center"
                            >
                                <span v-if="lang == 'en'">Product</span>
                                <span v-if="lang == 'es'">Produtos</span>
                                <span v-if="lang == 'pt'">Produtos</span>
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                <span v-if="lang == 'en'">Price</span>
                                <span v-if="lang == 'es'">Price</span>
                                <span v-if="lang == 'pt'">Valor</span>
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                <span v-if="lang == 'en'">Qty</span>
                                <span v-if="lang == 'es'">Qtd</span>
                                <span v-if="lang == 'pt'">Qtd</span>
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                <span>Total</span>
                            </v-col>
                        </v-row>
                        <v-row v-for="(item, index) in cart.products" :key="index">
                            <v-col
                                    sm="1"
                                    class="text-center"
                                    v-if="$vuetify.breakpoint.mdAndUp"
                            >
                                <v-img :src="item.img" heigth="100px" width="100px"></v-img>
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="5"
                                    class="text-center"
                            >
                                <v-img :src="item.img" height="60px" width="60px" style="margin: 0 auto" v-if="$vuetify.breakpoint.smAndDown"></v-img>
                                <span v-if="lang == 'en'">{{ item.product_en }}</span>
                                <span v-if="lang == 'es'">{{ item.product_es }}</span>
                                <span v-if="lang == 'pt'">{{ item.product_pt }}</span>
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                ${{ item.value | number_format_real }}
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                <v-text-field v-model="item.qty" @change="updateProductCart(index,'manual')" @keyup="updateProductCart(index,'manual')">
                                    <v-icon slot="append" color="red" @click="updateProductCart(index,'add')">mdi-plus</v-icon>
                                    <v-icon slot="prepend" color="green" @click="updateProductCart(index,'remove')">mdi-minus</v-icon>
                                </v-text-field>
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                ${{ item.value*item.qty | number_format_real }}
                                <v-btn icon class="float-right d-none d-sm-flex" @click="deleteProductCart(index)" :loading="loading.cart" >
                                    <v-icon color="red" >mdi-delete</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                    cols="12"
                                    class="text-center d-flex d-sm-none"
                            >
                                <v-btn icon block @click="deleteProductCart(index)" :loading="loading.cart" >
                                    <v-icon color="red" >mdi-delete</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-divider :key="index+'a'"></v-divider>
                            </v-col>
                        </v-row>
                        <div v-if="cart.total > 0">
                            <v-form v-if="userLogged == false"
                                    ref="formEmail"
                                    onsubmit="return false"
                            >
                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold mb-6 text-center display-2 success" style="color: white">Total ${{ cart.total | number_format_real}}</p>
                                    </v-col>
                                    <v-col cols="6" class="offset-3">
                                        <v-text-field
                                                :loading="loading.login"
                                                :rules="emailRules"
                                                v-model="customer.email"
                                                label="Enter your email to continue"
                                                prepend-inner-icon="mdi-email"
                                                append-outer-icon="mdi-send"
                                                @click:append-outer="step1"
                                                v-on:keyup.enter="step1"
                                                outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="offset-3">
                                        <p class="mb-6 text-center body-1" v-if="lang == 'en' ">Or</p>
                                        <p class="mb-6 text-center body-1" v-if="lang == 'es' ">O</p>
                                        <p class="mb-6 text-center body-1" v-if="lang == 'pt' ">Ou</p>
                                        <v-btn
                                                large
                                                block
                                                color="#3b5998"
                                                dark
                                                onclick="loginFB();"
                                        >
                                            <v-icon left>mdi-facebook</v-icon>
                                            <span v-if="lang == 'en' ">Continue with Facebook</span>
                                            <span v-if="lang == 'pt' ">Continuar com Facebook</span>
                                            <span v-if="lang == 'es' ">Continuar con Facebook</span>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6" class="offset-3">
                                        <v-card shaped dark>
                                            <v-card-title>
                                                We use your email 100% securely to:
                                            </v-card-title>
                                            <v-card-text>
                                                <ul>
                                                    <li>Identify your profile </li>
                                                    <li>Notify about the progress of your order</li>
                                                    <li>Manage your shopping history </li>
                                                    <li>Speed up filling in your information </li>
                                                </ul>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-form>
                            <v-btn v-else class="mb-5" tile large block color="orange" @click="goCheckout">
                                Continue
                                <v-icon right>mdi-arrow-right</v-icon>
                            </v-btn>
                            <v-form v-if="userLogged == false"
                                    ref="formPassword"
                            >
                                <v-dialog v-model="modalPassword" scrollable persistent max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="primary" icon small dark class="float-right ml-5" v-on="on">
                                            <v-icon>mdi-help</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            Welcome back
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <v-btn color="secondary" fab x-small dark @click="modalPassword = false">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            We realize that you already have a registration in our store.
                                            <br><br>
                                            To proceed with the purchase please identify yourself.
                                            <br><br>
                                            Choose one of the options below.
                                        </v-card-text >
                                        <v-divider></v-divider>
                                        <v-card-text v-if="passBtn">
                                            <v-text-field
                                                    v-if="typeLogin == 'pass'"
                                                    :rules="passwordRules"
                                                    :loading="loading.password"
                                                    label="Password*"
                                                    type="password"
                                                    append-outer-icon="mdi-send"
                                                    @click:append-outer="loginPassword"
                                                    v-model="customer.password">
                                            </v-text-field>
                                            <v-text-field v-else label="Key" type="text" ></v-text-field>
                                        </v-card-text>
                                        <v-divider v-if="passBtn"></v-divider>
                                        <v-row>
                                            <v-col cols="12">
                                                <div v-if="erro">
                                                    <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                                                        {{ item }}
                                                    </v-alert>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-card-actions>
                                            <v-row v-if="passBtn">
                                                <v-col cols="12" md="6">
                                                    <v-btn color="blue darken-1" @click="passBtn = false">Back</v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row v-else>
                                                <v-col cols="12" md="6">
                                                    <v-btn color="blue darken-1" small @click="passBtn = true;typeLogin='pass'">Type your password</v-btn>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-btn color="blue darken-1" small @click="passBtn = true;typeLogin='key'">Receive a quick key by email</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-form>
                        </div>
                        <v-row v-else>
                            <v-col cols="12" class="text-center">
                                <p class="display-2 mt-5">No products</p>
                                <v-btn class="mt-5" tile outlined color="success" :to="'/'">
                                    <v-icon left>mdi-plus</v-icon>
                                    <span v-if="lang == 'en'">Add more Products</span>
                                    <span v-if="lang == 'es'">Agregar más productos</span>
                                    <span v-if="lang == 'pt'">Adicionar mais produtos</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else-if="tpl == 'checkout' ">
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold mb-6 text-center display-2">Checkout</p>
                <hr class="mb-5">
                <v-btn class="mb-5" v-if="loading.order == false" tile outlined color="success" @click="backToCart">
                    <v-icon left>mdi-arrow-left</v-icon>
                    <span v-if="lang == 'en'">Back to Cart</span>
                    <span v-if="lang == 'es'">Volver al carro</span>
                    <span v-if="lang == 'pt'">Voltar ao carrinho</span>
                </v-btn>
            </v-col>
            <!--customer-->
            <v-col
                    cols="12"
                    sm="6"
                    lg="4"
            >
                <v-card
                        :loading="loading.personal"
                >

                    <v-card-title>
                        <p class="font-weight-bold mb-6 subtitle-1 text-center display-2">
                            Personal data <v-btn x-small color="secondary" outlined @click="backToCart">It's not me</v-btn>
                        </p>
                    </v-card-title>
                    <v-card-text>
                        <v-form v-if="customer.edit"
                                ref="formCreate"
                        >
                            <v-container >
                                <v-row>
                                    <v-col
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-if="lang == 'en' "
                                                v-model="customer.name"
                                                maxlength="200"
                                                counter="200"
                                                :rules="nameRules"
                                                label="Name"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="lang == 'es' "
                                                v-model="customer.name"
                                                maxlength="200"
                                                counter="200"
                                                :rules="nameRules"
                                                label="Nombre"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="lang == 'pt' "
                                                v-model="customer.name"
                                                maxlength="200"
                                                counter="200"
                                                :rules="nameRules"
                                                label="Nome"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="customer.email"
                                                readonly
                                                maxlength="200"
                                                counter="200"
                                                label="Email"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-if="lang == 'en' "
                                                v-model="customer.telephone"
                                                maxlength="50"
                                                label="Telephone"
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="lang == 'es' "
                                                v-model="customer.telephone"
                                                maxlength="50"
                                                label="Telephone"
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="lang == 'pt' "
                                                v-model="customer.telephone"
                                                maxlength="50"
                                                label="Telefone"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-if="existCustomer == false"
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-if="lang == 'en' "
                                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="show1 ? 'text' : 'password'"
                                                hint="At least 8 characters"
                                                @click:append="show1 = !show1"
                                                v-on:keyup.enter="registerEmail"
                                                v-model="customer.password"
                                                maxlength="100"
                                                counter="100"
                                                :rules="passwordRules"
                                                label="Password"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="lang == 'es' "
                                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="show1 ? 'text' : 'password'"
                                                hint="At least 8 characters"
                                                @click:append="show1 = !show1"
                                                v-on:keyup.enter="registerEmail"
                                                v-model="customer.password"
                                                maxlength="100"
                                                counter="100"
                                                :rules="passwordRules"
                                                label="Password"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                v-if="lang == 'pt' "
                                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="show1 ? 'text' : 'password'"
                                                hint="Minimo 8 caracteres"
                                                @click:append="show1 = !show1"
                                                v-on:keyup.enter="registerEmail"
                                                v-model="customer.password"
                                                maxlength="100"
                                                counter="100"
                                                :rules="passwordRules"
                                                label="Senha"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-if="existCustomer"
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-btn
                                                :loading="loading.register"
                                                color="success"
                                                class="mr-4"
                                                @click="editCustomer"
                                        >
                                            <span v-if="lang == 'en' ">Continue</span>
                                            <span v-if="lang == 'pt' ">Continuar</span>
                                            <span v-if="lang == 'es' ">Continuar</span>
                                        </v-btn>
                                    </v-col>
                                    <v-col v-else
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-btn
                                                :loading="loading.register"
                                                color="success"
                                                class="mr-4"
                                                @click="registerEmail"
                                        >
                                            <span v-if="lang == 'en' ">Continue</span>
                                            <span v-if="lang == 'pt' ">Continuar</span>
                                            <span v-if="lang == 'es' ">Continuar</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                        <v-simple-table v-else dense>
                            <template v-slot:default>
                                <tbody>
                                <tr>
                                    <th>Name</th>
                                    <td>
                                        {{customer.name}}
                                        <v-btn color="primary" icon small dark class="float-right ml-5" v-if="customer.edit == false && userLogged" @click="customer.edit = true">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-form v-if="userLogged == false"
                                                ref="formPassword1"
                                        >
                                            <v-dialog v-model="modal" scrollable max-width="500px" v-if="customer.edit == false && userLogged == false">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn color="primary" icon small dark class="float-right ml-5" v-on="on">
                                                        <v-icon>mdi-help</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-card-title>
                                                        Why do my data appear with asterisks?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <v-btn color="secondary" fab x-small dark @click="modal = false">
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                        Since you are not authenticated, we protect your data by masking it with asterisks.
                                                        <br><br>
                                                        If you recognize that these are your personal data and your address, you can move on!
                                                        <br><br>
                                                        If you want to see or change them, simply identify yourself below.
                                                    </v-card-text >
                                                    <v-divider></v-divider>
                                                    <v-card-text v-if="passBtn">
                                                        <v-text-field
                                                                v-if="typeLogin == 'pass'"
                                                                :rules="passwordRules"
                                                                :loading="loading.password"
                                                                label="Password*"
                                                                type="password"
                                                                append-outer-icon="mdi-send"
                                                                @click:append-outer="loginPassword1"
                                                                v-model="customer.password">
                                                        </v-text-field>
                                                        <v-text-field v-else label="Key" type="text"></v-text-field>
                                                    </v-card-text>
                                                    <v-divider v-if="passBtn"></v-divider>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <div v-if="erro">
                                                                <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                                                                    {{ item }}
                                                                </v-alert>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                    <v-card-actions>
                                                        <v-row v-if="passBtn">
                                                            <v-col cols="12" md="6">
                                                                <v-btn color="blue darken-1" @click="passBtn = false">Back</v-btn>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-else>
                                                            <v-col cols="12" md="6">
                                                                <v-btn color="blue darken-1" small @click="passBtn = true;typeLogin='pass'">Type your password</v-btn>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <v-btn color="blue darken-1" small @click="passBtn = true;typeLogin='key'">Receive a quick key by email</v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td>
                                        {{customer.email}}
                                    </td>
                                </tr>
                                <tr v-if="customer.telephone">
                                    <th >Telephone</th>
                                    <td>
                                        {{customer.telephone}}
                                        <v-btn color="primary" icon small dark class="float-right ml-5" v-if="customer.edit == false && userLogged" @click="customer.edit = true">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn color="primary" icon small dark class="float-right ml-5" v-if="customer.edit == false && userLogged == false" @click="modal = true">
                                            <v-icon>mdi-help</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <tr v-if="existCustomer && customer.edit == false && address.edit == false">
                                    <th>Shipping</th>
                                    <td>
                                            <span v-if="address.country == 'BRA' ">
                                                {{address.address}}, {{address.number}} {{address.complement}} - {{address.neighborhood}} - {{address.city}} - {{address.state}} - {{address.zipcode}}
                                            </span>
                                        <span v-else>
                                                {{address.address}} - {{address.gatecode}} - {{address.city}} {{address.state}} - {{address.zipcode}}
                                            </span>
                                        <v-btn color="primary" icon small dark class="float-right ml-5" v-if="address.edit == false && userLogged" @click="address.edit = true">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn color="primary" icon small dark class="float-right ml-5" v-if="address.edit == false && userLogged == false" @click="modal = true">
                                            <v-icon>mdi-help</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
                <!--CPF-->
                <v-form
                        ref="formCPF"
                >
                    <v-dialog v-model="modalCPF" scrollable persistent max-width="500px">
                        <v-card>
                            <v-card-title>
                                Hello, {{ customer.name}}
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <br><br>
                                For the destination country it is necessary to inform a CPF to continue.
                                <br><br>
                                Please tell us your CPF below.
                            </v-card-text >
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-text-field
                                        :rules="CPFRules"
                                        :loading="loading.cpf"
                                        label="CPF*"
                                        type="text"
                                        append-outer-icon="mdi-send"
                                        @click:append-outer="registerCPF"
                                        v-on:keyup.enter="registerCPF"
                                        v-mask="maskCPF"
                                        v-model="customer.cpf">
                                </v-text-field>
                            </v-card-text>
                            <v-divider v-if="passBtn"></v-divider>
                        </v-card>
                    </v-dialog>
                </v-form>
            </v-col>
            <!--shipping-->
            <v-col
                    v-if="existCustomer && address.edit && customer.edit == false"
                    cols="12"
                    sm="6"
                    lg="4"
            >
                <v-card
                        :loading="loading.shipping"
                >
                    <v-card-title>
                        <p class="font-weight-bold mb-6 subtitle-1 text-center display-2">
                            Shipping
                        </p>
                        <hr>
                    </v-card-title>
                    <v-card-text>
                        <v-list v-if="addressList" shaped>
                            <v-list-item-group v-model="firstSelect" color="primary">
                                <v-list-item
                                        v-for="(item, i) in addressList"
                                        :key="i"
                                        @click="saveAddress(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-home</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title >
                                            <span v-if="item.pais == 'BRA' ">{{ item.endereco }}, {{ item.numero }} {{ item.complemento }} - {{ item.bairro }} - {{ item.cidade }} - {{ item.estado }} - {{ item.zipcode }}</span>
                                            <span v-if="item.pais == 'USA' ">{{ item.endereco }} - {{ item.gatecode }} - {{ item.cidade }} - {{ item.estado }} - {{ item.zipcode }}</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="userLogged" @click="addressList=false">
                                    <v-list-item-icon>
                                        <v-icon>mdi-plus-circle-outline</v-icon>
                                        <v-list-item-title>
                                            New Address.
                                        </v-list-item-title>
                                    </v-list-item-icon>
                                </v-list-item>
                                <v-list-item v-else @click="modal = true">
                                    <v-list-item-icon>
                                        <v-icon>mdi-plus-circle-outline</v-icon>
                                        <v-list-item-title>
                                            New Address
                                        </v-list-item-title>
                                    </v-list-item-icon>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <v-form v-else-if="address.edit"
                                ref="formAddress"
                        >
                            <v-container >
                                <v-row>
                                    <!--coutry-->
                                    <v-col
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-select
                                                v-model="address.country"
                                                :items="country"
                                                label="Country/Region"
                                                outlined
                                        ></v-select>
                                    </v-col>
                                    <!--zip-->
                                    <v-col
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.zipcode"
                                                maxlength="8"
                                                :rules="zipRules"
                                                label="Zipcode"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <!--address-->
                                    <v-col
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.address"
                                                maxlength="200"
                                                counter="200"
                                                :rules="addressRules"
                                                label="Address"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <!--number-->
                                    <v-col v-if="address.country == 'BRA' "
                                            cols="12"
                                            lg="6"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.number"
                                                maxlength="100"
                                                counter="100"
                                                :rules="numberRules"
                                                label="Number"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <!--complement-->
                                    <v-col v-if="address.country == 'BRA' "
                                            cols="12"
                                            lg="6"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.complement"
                                                maxlength="100"
                                                counter="100"
                                                label="Complement"
                                        ></v-text-field>
                                    </v-col>
                                    <!--bairro-->
                                    <v-col v-if="address.country == 'BRA' "
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.neighborhood"
                                                maxlength="100"
                                                counter="100"
                                                :rules="neighborhoodRules"
                                                label="Neighborhood"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <!--city-->
                                    <v-col
                                            cols="12"
                                            lg="6"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.city"
                                                maxlength="100"
                                                counter="100"
                                                :rules="cityRules"
                                                label="City"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <!--state-->
                                    <v-col
                                            cols="12"
                                            lg="6"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.state"
                                                maxlength="100"
                                                counter="100"
                                                :rules="stateRules"
                                                label="State"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                    <!--gate-->
                                    <v-col v-if="address.country == 'USA' "
                                            cols="12"
                                            class="text-center"
                                    >
                                        <v-text-field
                                                v-model="address.gatecode"
                                                maxlength="100"
                                                counter="100"
                                                label="Gate code"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                           cols="12"
                                           class="text-center"
                                    >
                                        <v-btn
                                                :loading="loading.shipping"
                                                color="success"
                                                class="mr-4"
                                                @click="registerAddress"
                                        >
                                            <span v-if="lang == 'en' ">Continue</span>
                                            <span v-if="lang == 'pt' ">Continuar</span>
                                            <span v-if="lang == 'es' ">Continuar</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
            <!--Summary-->
            <v-col
                    cols="12"
                    sm="6"
                    lg="4"
            >
                <v-card
                        :loading="loading.summary"
                >
                    <v-card-title>
                        <p class="font-weight-bold mb-6 subtitle-1 text-center display-2">Summary</p>
                        <hr>
                    </v-card-title>
                    <v-card-text>
                        <v-row style="font-weight: bold;" class="d-none d-sm-flex">
                            <v-col
                                    cols="5"
                                    class="text-center"
                            >
                                <span v-if="lang == 'en'">Product</span>
                                <span v-if="lang == 'es'">Produtos</span>
                                <span v-if="lang == 'pt'">Produtos</span>
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                <span v-if="lang == 'en'">Price</span>
                                <span v-if="lang == 'es'">Price</span>
                                <span v-if="lang == 'pt'">Valor</span>
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                <span v-if="lang == 'en'">Qty</span>
                                <span v-if="lang == 'es'">Qtd</span>
                                <span v-if="lang == 'pt'">Qtd</span>
                            </v-col>
                            <v-col
                                    cols="2"
                                    class="text-center"
                            >
                                <span>Total</span>
                            </v-col>
                        </v-row>
                        <v-row v-for="(item, index) in cart.products" :key="index">
                            <v-col
                                    cols="12"
                                    sm="5"
                                    class="text-center"
                            >
                                <v-img :src="item.img" height="60px" width="60px" style="margin: 0 auto"></v-img>
                                <span v-if="lang == 'en'">{{ item.product_en }}</span>
                                <span v-if="lang == 'es'">{{ item.product_es }}</span>
                                <span v-if="lang == 'pt'">{{ item.product_pt }}</span>
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                ${{ item.value | number_format_real }}
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                {{ item.qty }}x
                            </v-col>
                            <v-col
                                    cols="12"
                                    sm="2"
                                    class="text-center"
                            >
                                ${{ item.value*item.qty | number_format_real }}
                            </v-col>
                            <v-col cols="12">
                                <v-divider :key="index+'a'"></v-divider>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;" v-if="cart.address.tax">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Total Products ${{ cart.subtotal | number_format_real}}</span>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;" v-if="cart.address.tax">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Tax ${{ cart.address.tax | number_format_real}}</span>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;" v-if="cart.address.price">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Shipping ${{ cart.address.price | number_format_real}}</span>
                            </v-col>
                        </v-row>
                        <v-row style="font-weight: bold;">
                            <v-col
                                    cols="12"
                                    class="font-weight-bold title"
                            >
                                <span class="float-right">Total ${{ cart.total | number_format_real}}</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- Finish-->
            <v-col
                    v-if="existCustomer && customer.edit == false && address.edit == false && loading.order == false"
                    cols="12"
                    sm="6"
                    lg="4"
            >
                <a href="javascript:void(0);" @click="finish">
                    <img class="opacity" src="https://donnawignall.com/wp-content/uploads/2019/01/Paypal-Button.png" style="max-width: 100%;padding-top: 20px;">
                </a>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    window.fbAsyncInit = function() {
        window.FB.init({
            appId      : '2143272185979954',
            cookie     : true,
            xfbml      : true,
            version    : 'v2.12'
        });
        window.FB.AppEvents.logPageView();
    };
    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    import { mask } from 'vue-the-mask';
    export default {
        props: {
            lang: { type: String },
            cart: { type: Object },
        },
        directives: {
            mask,
        },
        metaInfo () {
            return {
                title: 'PPS Brands - Cart',
                meta: [
                    {description: 'PPS Brands - Cart'},
                    {keywords: 'PPS Brands - Cart'}
                ]
            }
        },
        data () {
            return {
                tpl:'cart',
                order:"/thanks/",
                show1: false, //password field
                loading:{
                    cart:false,
                    password:false,
                    login:false,
                    personal:true,
                    shipping:true,
                    summary:true,
                    register:false,
                    order:false,
                    cpf:false,
                },
                country:[
                    'USA','BRA'
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
                nameRules: [
                    v => !!v || 'Name is required'
                ],
                zipRules: [
                    v => !!v || 'zipcode is required'
                ],
                stateRules: [
                    v => !!v || 'state is required'
                ],
                cityRules: [
                    v => !!v || 'city is required'
                ],
                addressRules: [
                    v => !!v || 'address is required'
                ],
                neighborhoodRules: [
                    v => !!v || 'neighborhood is required'
                ],
                numberRules: [
                    v => !!v || 'number is required'
                ],
                passwordRules: [
                    v => !!v || 'password is required',
                    v => v.length >= 8 || 'Min 8 characters',
                ],
                CPFRules: [
                    v => !!v || 'CPF is required',
                    v => v.length >= 14 || 'Min 14 characters',
                ],
                userLogged:false,
                existCustomer:false,
                existAddress:false,
                customer:{
                    id:"",
                    email:"",
                    name:"",
                    password:"",
                    telephone:"",
                    cpf:"",
                    edit:true,
                },
                address:{
                    zipcode:'',
                    address:'',
                    city:'',
                    state:'',
                    gatecode:'',
                    neighborhood:'',
                    number:'',
                    complement:'',
                    country:'USA',
                    edit:true
                },
                addressList:{},
                firstSelect:0,
                modal: false,
                modalPassword: false,
                modalCPF: false,
                passBtn:false,
                typeLogin:'pass',
                erro:false,
                msg:[],
                maskCPF:'###.###.###-##'
            }
        },
        methods:{
            init(){
                //localStorage.removeItem('hash');
                this.loading.summary = false;
                //checkLogin
                if (localStorage.hash) {
                    //check hasg
                    var arr = {
                        hash:localStorage.hash
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/customer/hash",arr).then(response => {
                        if(response.data.erro == '1'){
                            this.existCustomer = false;
                            this.loading.personal = false;
                            this.customer.edit = true;
                            console.log("Invalid Hash");
                        }else{
                            if(localStorage.CartStep == 'checkout'){
                                this.tpl = 'checkout';
                            }
                            this.userLogged = true;
                            //personal
                            this.loading.personal = false;
                            this.customer.edit = false;
                            this.existCustomer = true;
                            //address
                            this.existAddress = false;
                            this.loading.shipping = false;

                            this.customer.id = response.data.data.id;
                            this.customer.name = response.data.data.name;
                            this.customer.email = response.data.data.email;
                            this.customer.telephone = response.data.data.telephone;
                            this.customer.cpf = response.data.data.cpf;

                            this.addressList = response.data.data.address;
                            var self = this;
                            setTimeout(function(){
                                    self.setAddress();
                                }, 1000
                            );
                        }
                    });
                }else if(localStorage.tempEmail){
                    this.customer.email = localStorage.tempEmail;
                    if(localStorage.CartStep == 'checkout'){
                        this.tpl = 'checkout';
                        this.getCustomerEmail(this.customer.email);
                        var self = this;
                        setTimeout(function(){
                                self.setAddress();
                            }, 1000
                        );
                    }
                }
                else{
                    this.existCustomer = false;
                    this.loading.personal = false;
                    this.customer.edit = true;
                }
            },
            backToCart(){
                localStorage.CartStep = 'cart';
                this.tpl = 'cart'
            },
            goCheckout(){
                localStorage.CartStep = 'checkout';
                this.tpl = 'checkout'
            },
            step1(){
                if (this.$refs.formEmail.validate()) {
                    this.loading.login = true;
                    this.getCustomerEmail(this.customer.email);
                }
            },
            loginPassword(){
                if (this.$refs.formPassword.validate()) {
                    this.loading.password = true;
                    this.erro = false;
                    this.msg = [];
                    var arr = {
                        email:this.customer.email,
                        password:this.customer.password,
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/customer/password",arr).then(response => {
                        this.loading.password = false;
                        if(response.data.erro == '1'){
                            this.erro = true;
                            this.msg = response.data.msg;
                        }else{
                            localStorage.hash = response.data.data.hash;
                            localStorage.CartStep = 'checkout';
                            this.tpl = 'checkout';
                            this.init();
                        }
                    });
                }
            },
            loginPassword1(){
                if (this.$refs.formPassword1.validate()) {
                    this.loading.password = true;
                    this.erro = false;
                    this.msg = [];
                    var arr = {
                        email:this.customer.email,
                        password:this.customer.password,
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/customer/password",arr).then(response => {
                        this.loading.password = false;
                        if(response.data.erro == '1'){
                            this.erro = true;
                            this.msg = response.data.msg;
                        }else{
                            localStorage.hash = response.data.data.hash;
                            localStorage.CartStep = 'checkout';
                            this.tpl = 'checkout';
                            this.init();
                        }
                    });
                }
            },
            getCustomerEmail(email){
                var arr = {
                    email:email
                };
                arr = JSON.stringify(arr);
                this.$http.post("https://api.ppsbrands.com/store/cart/email",arr).then(response => {
                    if(!(response.data.erro == '1')){
                        this.loading.login = false;
                        //check user
                        if(response.data.data.id){
                            console.log("user exist");
                            this.existCustomer = true;
                            this.customer.edit = false;
                            this.customer.id = response.data.data.id;
                            this.customer.name = response.data.data.name;
                            this.customer.telephone = response.data.data.telephone;
                            this.customer.cpf = response.data.data.cpf;
                            this.addressList = response.data.data.address;
                            if(Object.keys(this.addressList).length > 0){
                                this.loading.shipping = false;
                                localStorage.CartStep = 'checkout';
                                this.tpl = 'checkout';
                            }else{
                                this.modalPassword = true;
                                localStorage.CartStep = 'cart';
                            }
                        }else{
                            console.log("new user");
                            this.customer.edit = true;
                            this.customer.existCustomer = false;
                            localStorage.CartStep = 'checkout';
                            this.tpl = 'checkout';
                        }
                        localStorage.tempEmail = this.customer.email;
                        this.loading.personal = false;
                    }
                });
            },
            updateProductCart(item,condition){
                var qty = parseInt(this.cart.products[item].qty);
                if(qty <= 0){
                    qty = 1;
                }
                if(condition == 'manual'){
                    this.cart.products[item].qty = qty;
                }else if(condition == 'add'){
                    this.cart.products[item].qty = qty+1;
                }else{
                    if(qty <= 1){
                        this.cart.products[item].qty = 1;
                    }else{
                        this.cart.products[item].qty = qty-1;
                    }
                }
                var arr = {
                    token:localStorage.token,
                    id:this.cart.products[item].id_product,
                    qty:qty,
                    action:'update',
                };
                arr = JSON.stringify(arr);
                this.$http.post("https://api.ppsbrands.com/store/cart/add",arr).then(response => {
                    if(response){
                        this.$emit('calculateQtyCart', false);
                    }
                });
            },
            deleteProductCart(item){
                this.loading.cart = true;
                var arr = {
                    token:localStorage.token,
                    id:this.cart.products[item].id_product,
                };
                arr = JSON.stringify(arr);
                this.$http.post("https://api.ppsbrands.com/store/cart/delete",arr).then(response => {
                    if(response){
                        this.loading.cart = false;
                        this.$emit('displayCart', false);
                        this.$emit('calculateQtyCart', false);
                    }
                });
            },
            registerEmail(){
                if (this.$refs.formCreate.validate()) {
                    this.loading.register = true;
                    this.loading.personal = true;
                    var arr = {
                        name:this.customer.name,
                        email:this.customer.email,
                        password:this.customer.password,
                        telephone:this.customer.telephone,
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/customer/create",arr).then(response => {
                        this.loading.register = false;
                        if(response.data.erro == '1'){
                            alert('erro');
                        }else{
                            localStorage.hash = response.data.data;
                            this.init();
                        }
                    });
                }
            },
            editCustomer(){
                if (this.$refs.formCreate.validate()) {
                    this.loading.register = true;
                    this.loading.personal = true;
                    var arr = {
                        hash:localStorage.hash,
                        id:this.customer.id,
                        name:this.customer.name,
                        email:this.customer.email,
                        telephone:this.customer.telephone,
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/customer/modify",arr).then(response => {
                        this.loading.register = false;
                        if(response.data.erro == '1'){
                            alert('erro');
                        }else{
                            this.init();
                        }
                    });
                }
            },
            registerAddress(){
                if (this.$refs.formAddress.validate()) {
                    this.loading.shipping = true;
                    var arr = {
                        token:localStorage.token,
                        zipcode:this.address.zipcode,
                        address:this.address.address,
                        city:this.address.city,
                        state:this.address.state,
                        gatecode:this.address.gatecode,
                        neighborhood:this.address.neighborhood,
                        number:this.address.number,
                        complement:this.address.complement,
                        country:this.address.country
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/cart/address",arr).then(response => {
                        this.loading.shipping = false;
                        if(response.data.erro == '1'){
                            alert('erro');
                        }else{
                            this.$emit('displayCart', false);
                            this.$emit('calculateQtyCart', false);
                            var self = this;
                            setTimeout(function(){
                                    self.init();
                                }, 500
                            );
                        }
                    });
                }
            },
            saveAddress(address){
                var arr = {
                    token:localStorage.token,
                    zipcode:address.zipcode,
                    address:address.endereco,
                    city:address.cidade,
                    state:address.estado,
                    gatecode:address.gatecode,
                    neighborhood:address.bairro,
                    number:address.numero,
                    complement:address.complemento,
                    country:address.pais
                };
                arr = JSON.stringify(arr);
                this.loading.shipping = true;
                this.$http.post("https://api.ppsbrands.com/store/cart/address",arr).then(response => {
                    this.loading.shipping = false;
                    if(response.data.erro == '1'){
                        alert('erro');
                    }else{
                        this.$emit('displayCart', false);
                        this.$emit('calculateQtyCart', false);
                        var self = this;
                        setTimeout(function(){
                                self.init();
                            }, 500
                        );
                    }
                });
            },
            setAddress(){
                //manual address
                if(this.cart.address){
                    this.address.edit = false;
                    this.address.zipcode = this.cart.address.zipcode;
                    this.address.address = this.cart.address.endereco;
                    this.address.city = this.cart.address.cidade;
                    this.address.state = this.cart.address.estado;
                    this.address.gatecode = this.cart.address.zipcode;
                    this.address.neighborhood = this.cart.address.bairro;
                    this.address.number = this.cart.address.numero;
                    this.address.complement = this.cart.address.complemento;
                    this.address.country = this.cart.address.pais;
                    this.address.tax = this.cart.address.tax;
                    //check customer CPF to Brazil
                    if(this.address.country == 'BRA' && this.customer.cpf == ''){
                        console.log("pedir CPF");
                        this.modalCPF = true;
                    }
                }else if(Object.keys(this.addressList).length > 0){
                    console.log("address list");
                }
                else if(this.userLogged){
                    console.log("address form");
                    this.address.edit = true;
                    this.addressList = false;
                }else{
                    console.log("force login");
                }

            },
            registerCPF(){
                if (this.$refs.formCPF.validate()) {
                    this.loading.cpf = true;
                    var arr = {
                        id:this.customer.id,
                        cpf:this.customer.cpf
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/customer/cpf",arr).then(response => {
                        if(response.data.erro == '0'){
                            this.loading.cpf = false;
                        }
                        this.modalCPF = false;
                        this.init();

                    });
                }
            },
            finish(){
                var arr = {
                    token:localStorage.token,
                    hash:this.customer.id,
                };
                arr = JSON.stringify(arr);
                this.loading.personal = true;
                this.loading.order = true;
                this.loading.shipping = true;
                this.loading.summary = true;
                this.$http.post("https://api.ppsbrands.com/store/cart/finish",arr).then(response => {
                    if(response.data.erro == false){
                        localStorage.CartStep = 'cart';
                        this.order = this.order+String(response.data.data);
                        setTimeout(function(){
                            console.log(this.order);
                            document.getElementById('thanksPage').click();
                            }, 500
                        );
                        this.$emit('displayCart', false);
                        this.$emit('calculateQtyCart', false);
                    }
                });
            },
            loginFacebook(email,name){
                var arr = {
                    email:email,
                    name:name
                };
                arr = JSON.stringify(arr);
                this.$http.post("https://api.ppsbrands.com/store/customer/facebook",arr).then(response => {
                    this.loading.login = false;
                    if(response.data.erro == '0'){
                        localStorage.hash = response.data.data;
                        this.init();
                        localStorage.CartStep = 'checkout';
                        this.tpl = 'checkout'
                    }
                });
            },
            fbTest(){
                var self = this;
                window.loginFB = function () {
                    window.FB.login(function(response) {
                        if (response.status === 'connected') {
                            window.FB.api('/me',{fields: 'name, email'}, function(response) {
                                self.loginFacebook(response.email,response.name);
                            });
                        }
                    }, {scope: 'public_profile,email'});
                    return false;
                }
            },
        },
        mounted(){
            this.fbTest();
            this.init();
            this.$emit('hiddenCart');
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>